import { render, staticRenderFns } from "./CompetenceSkillsIndex.vue?vue&type=template&id=b6f20be0&scoped=true&"
import script from "./CompetenceSkillsIndex.vue?vue&type=script&lang=js&"
export * from "./CompetenceSkillsIndex.vue?vue&type=script&lang=js&"
import style0 from "./CompetenceSkillsIndex.vue?vue&type=style&index=0&id=b6f20be0&lang=scss&scoped=true&"
import style1 from "./CompetenceSkillsIndex.vue?vue&type=style&index=1&id=b6f20be0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f20be0",
  null
  
)

export default component.exports